import dynamic from 'next/dynamic';

const EmbedComponent = dynamic(() => import(`./Embed`));

const components = {
    AUDIO: dynamic(() => import(`./Audio`)),
    CITA: dynamic(() => import(`./Cites`)),
    COMPARTIR: dynamic(() => import(`components/3catinfo/Compartir`)),
    IMATGE: dynamic(() => import(`./ImatgeComponent`)),
    TEXT: dynamic(() => import(`./TextComponent`)),
    VIDEO: dynamic(() => import(`./Video`)),
    VIDEO_ANIMAT: dynamic(() => import(`./VideoAnimat`)),
    BLUESKY: EmbedComponent,
    CARTO: EmbedComponent,
    DATAWRAPPER: EmbedComponent,
    EMBED: EmbedComponent,
    FACEBOOK: EmbedComponent,
    FLOURISH: EmbedComponent,
    IFRAME_3CAT: EmbedComponent,
    INFOGRAM: EmbedComponent,
    INSTAGRAM: EmbedComponent,
    QUALIFIO: EmbedComponent,
    OPTA: EmbedComponent,
    TIKTOK: EmbedComponent,
    TWITTER: EmbedComponent,
    YOUTUBE: EmbedComponent,
    VIMEO: EmbedComponent
};

export { components };
